import { render, staticRenderFns } from "./BindingSampleFullScreenDialog.vue?vue&type=template&id=5f165f4a&scoped=true&"
import script from "./BindingSampleFullScreenDialog.vue?vue&type=script&lang=js&"
export * from "./BindingSampleFullScreenDialog.vue?vue&type=script&lang=js&"
import style0 from "./BindingSampleFullScreenDialog.vue?vue&type=style&index=0&lang=css&"
import style1 from "./BindingSampleFullScreenDialog.vue?vue&type=style&index=1&id=5f165f4a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f165f4a",
  null
  
)

export default component.exports